module.exports = __webpack_public_path__ + "static/media/book_animation_stars.93193da5.png";